export const items = [
    {
        date: ['1', '5', ' ', 'm', 'a', 'y'],
        preview: require('./items/1.webp'),
        detail: require('./items/1-detail.webp'),
        text: ['Принято считать, что дома класса премиум', 'должны обладать общими локационными', 'характеристиками. Но любая общность делает', 'исключительное – стандартным. LEGENDA', 'традиционно держится своих взглядов в ущерб', 'массовым стереотипам. Институтский, 16 –', 'премиум-класс с новыми традициями своего', ' сегмента.']
    },
    {
        date: ['1', '4', ' ', 'm', 'a', 'y'],
        preview: require('./items/2.webp'),
        detail: require('./items/2-detail.webp'),
        text: ['Принято считать, что дома класса премиум', 'должны обладать общими локационными', 'характеристиками. Но любая общность делает', 'исключительное – стандартным. LEGENDA', 'традиционно держится своих взглядов в ущерб', 'массовым стереотипам. Институтский, 16 –', 'премиум-класс с новыми традициями своего', ' сегмента.']
    },
    {
        date: ['1', '3', ' ', 'm', 'a', 'y'],
        preview: require('./items/3.webp'),
        detail: require('./items/3-detail.webp'),
        text: ['Принято считать, что дома класса премиум', 'должны обладать общими локационными', 'характеристиками. Но любая общность делает', 'исключительное – стандартным. LEGENDA', 'традиционно держится своих взглядов в ущерб', 'массовым стереотипам. Институтский, 16 –', 'премиум-класс с новыми традициями своего', ' сегмента.']
    },
    {
        date: ['9', ' ', 'm', 'a', 'y'],
        preview: require('./items/1.webp'),
        detail: require('./items/1-detail.webp'),
        text: ['Принято считать, что дома класса премиум', 'должны обладать общими локационными', 'характеристиками. Но любая общность делает', 'исключительное – стандартным. LEGENDA', 'традиционно держится своих взглядов в ущерб', 'массовым стереотипам. Институтский, 16 –', 'премиум-класс с новыми традициями своего', ' сегмента.']
    },
    {
        date: ['3', '0', ' ', 'a', 'p', 'r', 'i', 'l'],
        preview: require('./items/2.webp'),
        detail: require('./items/2-detail.webp'),
        text: ['Принято считать, что дома класса премиум', 'должны обладать общими локационными', 'характеристиками. Но любая общность делает', 'исключительное – стандартным. LEGENDA', 'традиционно держится своих взглядов в ущерб', 'массовым стереотипам. Институтский, 16 –', 'премиум-класс с новыми традициями своего', ' сегмента.']
    },
    {
        date: ['1', '5', ' ', 'a', 'p', 'r', 'i', 'l'],
        preview: require('./items/3.webp'),
        detail: require('./items/3-detail.webp'),
        text: ['Принято считать, что дома класса премиум', 'должны обладать общими локационными', 'характеристиками. Но любая общность делает', 'исключительное – стандартным. LEGENDA', 'традиционно держится своих взглядов в ущерб', 'массовым стереотипам. Институтский, 16 –', 'премиум-класс с новыми традициями своего', ' сегмента.']
    },
    {
        date: ['9', ' ', 'm', 'a', 'y'],
        preview: require('./items/1.webp'),
        detail: require('./items/1-detail.webp'),
        text: ['Принято считать, что дома класса премиум', 'должны обладать общими локационными', 'характеристиками. Но любая общность делает', 'исключительное – стандартным. LEGENDA', 'традиционно держится своих взглядов в ущерб', 'массовым стереотипам. Институтский, 16 –', 'премиум-класс с новыми традициями своего', ' сегмента.']
    },
    {
        date: ['3', '0', ' ', 'a', 'p', 'r', 'i', 'l'],
        preview: require('./items/2.webp'),
        detail: require('./items/2-detail.webp'),
        text: ['Принято считать, что дома класса премиум', 'должны обладать общими локационными', 'характеристиками. Но любая общность делает', 'исключительное – стандартным. LEGENDA', 'традиционно держится своих взглядов в ущерб', 'массовым стереотипам. Институтский, 16 –', 'премиум-класс с новыми традициями своего', ' сегмента.']
    },
    {
        date: ['1', '5', ' ', 'a', 'p', 'r', 'i', 'l'],
        preview: require('./items/3.webp'),
        detail: require('./items/3-detail.webp'),
        text: ['Принято считать, что дома класса премиум', 'должны обладать общими локационными', 'характеристиками. Но любая общность делает', 'исключительное – стандартным. LEGENDA', 'традиционно держится своих взглядов в ущерб', 'массовым стереотипам. Институтский, 16 –', 'премиум-класс с новыми традициями своего', ' сегмента.']
    },
    {
        date: ['9', ' ', 'm', 'a', 'y'],
        preview: require('./items/1.webp'),
        detail: require('./items/1-detail.webp'),
        text: ['Принято считать, что дома класса премиум', 'должны обладать общими локационными', 'характеристиками. Но любая общность делает', 'исключительное – стандартным. LEGENDA', 'традиционно держится своих взглядов в ущерб', 'массовым стереотипам. Институтский, 16 –', 'премиум-класс с новыми традициями своего', ' сегмента.']
    },
    {
        date: ['3', '0', ' ', 'a', 'p', 'r', 'i', 'l'],
        preview: require('./items/2.webp'),
        detail: require('./items/2-detail.webp'),
        text: ['Принято считать, что дома класса премиум', 'должны обладать общими локационными', 'характеристиками. Но любая общность делает', 'исключительное – стандартным. LEGENDA', 'традиционно держится своих взглядов в ущерб', 'массовым стереотипам. Институтский, 16 –', 'премиум-класс с новыми традициями своего', ' сегмента.']
    },
    {
        date: ['1', '5', ' ', 'a', 'p', 'r', 'i', 'l'],
        preview: require('./items/3.webp'),
        detail: require('./items/3-detail.webp'),
        text: ['Принято считать, что дома класса премиум', 'должны обладать общими локационными', 'характеристиками. Но любая общность делает', 'исключительное – стандартным. LEGENDA', 'традиционно держится своих взглядов в ущерб', 'массовым стереотипам. Институтский, 16 –', 'премиум-класс с новыми традициями своего', ' сегмента.']
    },
]